import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading, token } = useAuth();
  if (loading) {
    return <div className="p-8 text-sm text-zinc-500">Chargement...</div>;
  }
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="p-8 text-sm text-red-700 bg-red-50 border border-red-200 m-8">
        Accès refusé : votre rôle ne permet pas de consulter cette page.
      </div>
    );
  }
  return children;
}
